import React, { Component } from 'react';
import FileUpload from './components/FileUpload'
import Report from './components/Report'
import axios from 'axios'
import logo from './images/logo.png'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect,
} from "react-router-dom";

import './App.css';

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      selectedFile: null,
      data: null,
      header: null,
      instructions: null
    }
  }

  onSubmit = (e) => {
    e.preventDefault()

    const data = new FormData()
    data.append('file', this.state.selectedFile)

    axios.post('/api/reports', data, {})
      .then(res => {
          this.setState({
            data: res.data.data,
            header: res.data.header,
            instructions: res.data.instructions
          })
        }
      )
  }

  onChange = (e) => {
    this.setState({
      selectedFile: e.target.files[0]
    })
  }


  styles = {

    container: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
    },

    logo: {
      width: '2in',
      margin: '20px',
    },
  }

  showReportLink = () => {
    if (this.state.data) {
      return <Link to="/report">View Report</Link>
    }
  }

  showReport = () => {
    if (this.state.data) {
      return <Report data={ this.state.data } header={ this.state.header } instructions={this.state.instructions} />
    } else {
      return <Redirect to="/" />
    }
  }


  render() {

    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <div style={ this.styles.container }>
              <img style={ this.styles.logo }
                   src={ logo }
                   alt='logo' />
              <FileUpload onChange={ this.onChange }
                          onSubmit={ this.onSubmit } />
              { this.showReportLink() }
            </div>
          </Route>

          <Route exact path="/report">
            { this.showReport() }
          </Route>

        </Switch>
      </Router>
    )
  }
}

export default App;
